import { render, staticRenderFns } from "./setLuxRadius.vue?vue&type=template&id=370a83de&scoped=true"
import script from "./setLuxRadius.vue?vue&type=script&lang=js"
export * from "./setLuxRadius.vue?vue&type=script&lang=js"
import style0 from "./setLuxRadius.vue?vue&type=style&index=0&id=370a83de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "370a83de",
  null
  
)

export default component.exports